// extracted by mini-css-extract-plugin
export default {"PFSServiceHeader":"PFSServiceHeader_PFSServiceHeader__UnoJ4","period":"PFSServiceHeader_period__zJi4H"};